import { render, staticRenderFns } from "./ViewShipmentDetails.vue?vue&type=template&id=fa44ddb4&scoped=true"
import script from "./ViewShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ViewShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewShipmentDetails.vue?vue&type=style&index=0&id=fa44ddb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa44ddb4",
  null
  
)

export default component.exports